import React from "react";
import { Link, Button } from "@heroui/react";
import logo from "../../../src/assets/img/MASH Primary logo White-aligned only text.svg";

export default function Description() {
  return (
    <div className="flex flex-col items-center text-center text-[rgb(204,204,204)] my-[6rem] sm:my-28 max-w-3xl mx-auto space-y-8">
      {/* Logo */}
      <img src={logo} alt="Logo" className="h-7 w-auto" />

      {/* Description */}
      <p className="text-[1.6rem] sm:text-[2rem] md:text-[2.4rem] leading-snug px-4 md:px-0">
        A new way to play.
      </p>
      <p className="text-[1.6rem] sm:text-[2rem] md:text-[2.4rem] text-white/60 px-4 md:px-0">
        Mash is building liquid, expressive, market-driven sports speculation.
      </p>
    </div>
  );
}
